import 'select2';

const paginationSort = {
    selectMenu: $('.js-select2Sort'),
    setSelectWidth() {
        this.selectMenu.each(function () {
            $(this).css({
                width: $(this).outerWidth() + 15 + 'px'
            });
        });
    },
    build() {
        this.selectMenu.select2({
            theme: 'sorting',
            width: 'style',
            dropdownAutoWidth: true,
            minimumResultsForSearch: Infinity
        });
    },
    bindEvents() {
        this.selectMenu.on('select2:select', function (evt) {
            evt.currentTarget.form.submit();
        });
    }
};

// DOM ready
$(() => {
    paginationSort.setSelectWidth();
    paginationSort.build();
    paginationSort.bindEvents();
});

export default paginationSort;
